export function removeExtraSpaces(text: string): string {
  return text.trim().replace(/  +/g, ' ');
}
